module.exports = __webpack_public_path__ + "img/sbp_3.936e5348.svg";